export class MetaDataRuleDefinitionDTO{
    
    public id!: number;
    public name!: string;
    public function!: string;
    public recordsIncluded!: string;
    public fieldSelection!: string;
    public fieldDataType!: string;
    
}